
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/[topic]/[article]",
      function () {
        return require("private-next-pages/resources/[topic]/[article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/[topic]/[article]"])
      });
    }
  